// this is an autogenerated file from App/Account/Content/Settings/Content/Onboarding/ApptTypes/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Onboarding_ApptTypes{
  result: onboarding_inputs_appointment_types {
    ok
  }
}

`